import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Index from '@/page/index'
import RedeemCenter from '@/page/RedeemCenter'
import paiwei from '@/page/paiwei'
import waitRobot from '@/page/waitRobot'
import pk from '@/page/pk'
import robot from '@/page/robot'
import single from '@/page/single'
import quizCenter from '@/page/quizCenter'
import wordCenter from '@/page/wordCenter'
import gameList from '@/page/gameList'
import gameIframe from '@/page/gameIframe'
import ImageQuestion from '@/page/ImageQuestion'
import videoQuestion from '@/page/videoQuestion'
import musicQuestion from '@/page/musicQuestion'
import liveQuiz from '@/page/liveQuiz'
import liveQuizList from '@/page/liveQuizList'
import liveQuizResult from '@/page/liveQuizResult'

import Language from '@/page/language'
import Faq from '@/page/faq'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import UserGuide from '@/page/userGuide'
import Login from '@/page/Login'
import otp from '@/page/otp'
import land from '@/page/land'
import Invitation from '@/page/invitation'
import Errors from '@/page/errors'

import rankList from '@/page/rankList'
import rank from '@/page/rank'
import redeemList from '@/page/redeemList'
import prize from '@/page/prize'
import rewardList from '@/page/rewardList'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		},
      beforeEnter: async (to, from, next) => {
        //路由守卫逻辑
        //路由带号码 直接登录
        if (to.query.mobile) {
          const res = await axios.post('https://battle.goquizgo.com/api/user/fast_login', {
            mobile: to.query.mobile
          })
          if (res.data.code === 1){
            localStorage.setItem('token', res.data.data.userinfo.token)
            localStorage.setItem('mobile',res.data.data.userinfo.mobile)
          }
        }
        next()
      }
    },{
      path: '/RedeemCenter',
      name: 'RedeemCenter',
      component: RedeemCenter,
      meta: {
        title: 'RedeemCenter'
      }
    },{
      path: '/paiwei',
      name: 'paiwei',
      component: paiwei,
      meta: {
        title: 'paiwei'
      }
    },{
      path: '/waitRobot',
      name: 'waitRobot',
      component: waitRobot,
      meta: {
        title: 'waitRobot'
      }
    },{
      path: '/pk',
      name: 'pk',
      component: pk,
      meta: {
        title: 'pk'
      }
    },{
      path: '/robot',
      name: 'robot',
      component: robot,
      meta: {
        title: 'robot'
      }
    },{
      path: '/single',
      name: 'single',
      component: single,
      meta: {
        title: 'single'
      }
    },{
      path: '/rankList',
      name: 'rankList',
      component: rankList,
      meta: {
        title: 'rankList'
      }
    },{
      path: '/rank',
      name: 'rank',
      component: rank,
      meta: {
        title: 'rank'
      }
    },{
      path: '/redeemList',
      name: 'redeemList',
      component: redeemList,
      meta: {
        title: 'redeemList'
      }
    },{
      path: '/prize',
      name: 'prize',
      component: prize,
      meta: {
        title: 'prize'
      }
    },{
      path: '/rewardList',
      name: 'rewardList',
      component: rewardList,
      meta: {
        title: 'rewardList'
      }
    },
    {
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },
    {
		path: '/land',
		name: 'land',
		component: land,
		meta: {
			title: 'land'
		}
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: Invitation,
      meta: {
        title: 'Invitation'
      }
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },
    {
      path: '/userGuide',
      name: 'userGuide',
      component: UserGuide,
      meta: {
        title: 'User Guide'
      }
    },
    {
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    },
    {
      path: '/quizCenter',
      name: 'quizCenter',
      component: quizCenter,
      meta: {
        title: 'quizCenter'
      }
    },
    {
      path: '/liveQuizList',
      name: 'liveQuizList',
      component: liveQuizList,
      meta: {
        title: 'Live Quiz'
      }
    },
    {
      path: '/liveQuiz',
      name: 'liveQuiz',
      component: liveQuiz,
      meta: {
        title: 'Live Quiz'
      }
    },
    {
      path: '/liveQuizResult',
      name: 'liveQuizResult',
      component: liveQuizResult,
      meta: {
        title: 'Live Quiz Result'
      }
    },
    {
      path: '/wordCenter',
      name: 'wordCenter',
      component: wordCenter,
      meta: {
        title: 'wordCenter'
      }
    },
    {
      path: '/gameList',
      name: 'gameList',
      component: gameList,
      meta: {
        title: 'gameList'
      }
    },
    {
      path: '/gameIframe',
      name: 'gameIframe',
      component: gameIframe,
      meta: {
        title: 'gameIframe'
      }
    },
    {
      path: '/ImageQuestion',
      name: 'ImageQuestion',
      component: ImageQuestion,
      meta: {
        title: 'ImageQuestion'
      }
    },
    {
      path: '/musicQuestion',
      name: 'musicQuestion',
      component: musicQuestion,
      meta: {
        title: 'musicQuestion'
      }
    },
    {
      path: '/videoQuestion',
      name: 'videoQuestion',
      component: videoQuestion,
      meta: {
        title: 'videoQuestion'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js